
define('jst!contacts/tour/_step1',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<h1><%= t("Contacts #contactsfeaturetour") %></h1>\n\n<p><%= t("All the people you share workspaces with are automatically listed here. #contactsfeaturetour") %></p>\n<p><%= t("All contact information is automatically available in the mobile apps! #contactsfeaturetour") %></p>\n');
 });

